import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const Payment = () => {
  const data = [
    ['Month', 'Payments Processed'],
    ['January', 100],
    ['February', 110],
    ['March', 105],
    ['April', 115],
    ['May', 120],
  ];

  const options = {
    title: 'Payments Processed',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Payments Processed' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#FF9800'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Payment;